export default __webpack_public_path__ + "static/media/Sword of Ashur.871179ce.jpg";